import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { PaymentStatus } from "../../types/collectionPoint";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";
import { Checkbox } from "../Checkbox";

export const PaidStatusFilter: React.FC<ColumnFilterProps> = ({
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const value = useSelector((state: RootState) => filterSelectorValue(state, fieldName));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const applyFilter = (isPaid: PaymentStatus | undefined) => {
    dispatch(
      filterUpdateAction({
        id: fieldName,
        name: fieldName,
        operator: FilterOperator.IsEqualTo,
        value: isPaid,
      })
    );
  };

  return (
    <>
      <div>
        <Checkbox
          checked={value?.value === PaymentStatus.Paid}
          onChange={(e) => {
            applyFilter(e.target.checked ? PaymentStatus.Paid : undefined);
          }}
        />
        {t(`filters.${fieldName}Paid`)}
      </div>
      <div>
        <Checkbox
          checked={value?.value === PaymentStatus.Unpaid}
          onChange={(e) => {
            applyFilter(e.target.checked ? PaymentStatus.Unpaid : undefined);
          }}
        />
        {t(`filters.${fieldName}UnPaid`)}
      </div>
    </>
  );
};
